import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_FindingView } from '@app/advisor-ui-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onFindingViewsUpdated = new ThunderDispatcherV3('__onFindingViewsUpdated');
export class ModuleFE_FindingView_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_FindingView, dispatch_onFindingViewsUpdated);
        this._v1 = {};
    }
    __searchFilterMapper = (item) => [item.label];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey,
                results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label,
                }))
            }];
    };
}
export const ModuleFE_FindingView = new ModuleFE_FindingView_Class();
//# sourceMappingURL=ModuleFE_FindingView.js.map